import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import ReloadIcon from '~/src/components/svg/ReloadIcon'
import { useAuthContext } from '~/src/context/AuthProvider'
import useAuthUser from '~/src/hooks/useAuthUser'
import { cn } from '~/src/lib/utils'

interface Props {
  disabled?: boolean
  processing?: boolean
  retries?: number
  refreshCallback?: () => Promise<void> | void
  authCallback?: () => void
}

const TryAgain: React.FC<Props> = ({
  disabled,
  processing,
  retries = 3,
  refreshCallback,
  authCallback,
}) => {
  const [retriesCount, setRetriesCount] = useState(0)
  const { authUser } = useAuthUser()
  const { openAuthModal } = useAuthContext()

  const allowedRetries = authUser?.uid ? retries : 1
  const maxRetriesReached = allowedRetries
    ? retriesCount >= allowedRetries
    : false

  const onClick = async () => {
    if (processing) return
    if (disabled) return

    if (maxRetriesReached) {
      if (!authUser?.uid) {
        if (authCallback) {
          authCallback()
        }

        openAuthModal({
          source: 'results-reload',
        })
      } else {
        alert('Servers are busy, please try again later.')
      }
      return
    }

    setRetriesCount((prev) => prev + 1)
    if (refreshCallback) {
      await refreshCallback()
    }
  }

  return (
    <button
      disabled={processing || disabled}
      className={cn({
        'opacity-50': maxRetriesReached,
      })}
      onClick={onClick}
    >
      <div className='flex items-center'>
        {!processing && maxRetriesReached && !!authUser?.uid ? (
          <ExclamationTriangleIcon height={18} />
        ) : (
          <ReloadIcon
            className={cn('opacity-50', {
              'animate-spin': processing,
            })}
            height={14}
          />
        )}
      </div>
    </button>
  )
}

export default TryAgain
